module.exports = __webpack_public_path__ + "img/500-fg-left.4550006.png";